import React, { Fragment, useEffect, useState, useRef } from 'react';
import { Box, Dialog, DialogTitle } from '@mui/material';
import OTPInput from 'react-otp-input';
import { ErrorToaster, SuccessToaster } from '../Helpers/toaster/Toaster';
import AuthServices from '../../apis/auth/AuthServices';
import LoaderStyleOne from '../Helpers/Loaders/LoaderStyleOne';
import { maskEmail, maskPhoneNumber } from '../../utils';

const OtpBox = ({ value, setValue }) => {
  return (
    <Box sx={{ my: 2 }}>
      <OTPInput
        value={value}
        numInputs={5}
        onChange={setValue}
        inputStyle={{
          width: "50px",
          height: "50px",
          fontSize: "26px",
          backgroundColor: '#eaeaea',
          color: "#14212a",
          border: "none",
          borderRadius: '8px',
          outline: "none",
        }}
        focusStyle={{
          width: "50px",
          height: "50px",
          fontSize: "26px",
          outline: "none",
          border: "none",
          borderRadius: '8px',
        }}
        containerStyle={{ display: "flex", justifyContent: "space-evenly" }}
        renderInput={(props) => <input {...props} />}
      />
    </Box>
  )
}

function VerifyOtp({ open, loading, error, otpNumber, email, register }) {

  const intervalRef = useRef(null);

  const [showButton, setShowButton] = useState(false);

  const [resendLoading, setResendLoading] = useState(false);

  // *For OTP Value
  const [numberOtp, setNumberOtp] = useState('');
  const [emailOtp, setEmailOtp] = useState('');

  // *For Resend OTP
  const [resendOtpTimer, setResendOtpTimer] = useState(true);
  const [mins, setMins] = useState();
  const [sec, setSec] = useState();

  const [attempts, setAttempts] = useState(0);

  // *For Otp Timer
  const otpTimer = (customDuration) => {
    try {
      const duration = customDuration || 60 * 2 // *Set OTP Time Duration
      let timer = duration, minutes, seconds;

      if (intervalRef.current) clearInterval(intervalRef.current);

      intervalRef.current = setInterval(function () {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        setMins(minutes)
        setSec(seconds)
        if (--timer < 0) {
          setResendOtpTimer(false)
          clearInterval(intervalRef.current)
          intervalRef.current = null;
        }
      }, 1000);
    } catch (error) {
      ErrorToaster(error)
    }
  }

  // *For Reset OTP Value
  const resetOtpValue = () => {
    setNumberOtp('')
    setEmailOtp('')
  }

  // *For Resend OTP
  const resendOtp = async () => {
    setResendLoading(true)
    try {
      if (otpNumber) {
        const { message } = await AuthServices.sendWhatsAppOtp({ phone_number: otpNumber })
        SuccessToaster(message)
      }
      if (email) {
        const { message } = await AuthServices.sendEmailOtp({ email: email })
        SuccessToaster(message)
      }

      const nextWait = attempts === 1 ? 180 : attempts === 2 ? 300 : 600;
      setAttempts(prev => prev + 1);
      otpTimer(nextWait)
      setResendOtpTimer(true)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setResendLoading(false)
    }
  }

  // *For Verify OTP
  const handleVerify = () => {
    try {
      const payload = {}
      if (otpNumber) {
        payload.whatsappOtpCode = numberOtp
      }
      if (email) {
        payload.emailOtpCode = emailOtp
      }
      register(payload)
    } catch (error) {
      console.log(' numberOtp => error:', error)
    }
  }

  useEffect(() => {
    otpTimer()
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (error) {
      resetOtpValue()
    }
  }, [error]);

  useEffect(() => {
    const inputPhoneLength = otpNumber ? numberOtp?.length === 5 ? true : false : true
    const inputEmailLength = email ? emailOtp?.length === 5 ? true : false : true
    if (inputPhoneLength && inputEmailLength) {
      setShowButton(true)
    } else {
      setShowButton(false)
    }
  }, [numberOtp, emailOtp]);

  return (
    <Dialog
      maxWidth="xs"
      open={open}
      sx={{ '& .MuiDialog-paper': { width: '80%', height: "auto", borderRadius: 2, py: { xs: 2, md: 4 }, px: { xs: 3, md: 6 } } }}
    >
      <DialogTitle sx={{ textAlign: "center", fontSize: '18px', fontWeight: 700 }}>OTP Verification</DialogTitle>
      <div className="mb-5">
        {otpNumber &&
          <>
            <p className="text-[13px] text-qgraytwo text-center">
              OTP has been sent to your
              preferred whatsapp number {maskPhoneNumber(otpNumber)}
            </p>
            <OtpBox
              value={numberOtp}
              setValue={(val) => setNumberOtp(val)}
            />
          </>
        }
        {email &&
          <>
            <p className="text-[13px] text-qgraytwo text-center">
              OTP has been sent to your
              preferred email {maskEmail(email)}
            </p>
            <OtpBox
              value={emailOtp}
              setValue={(val) => setEmailOtp(val)}
            />
          </>
        }
        {error &&
          <p className="text-[12px] text-qred text-center">You have entered invalid OTP code</p>
        }
      </div>
      <div className="mb-2">
        {resendOtpTimer ? (
          <p className="text-[13px] font-semibold text-center text-qblue">
            {mins}:{sec}
          </p>
        ) : (
          <Fragment>
            <p className="text-[13px] text-qgraytwo text-center mb-2">
              Don’t received OTP code?
            </p>
            <button
              type="button"
              disabled={resendLoading}
              onClick={() => resendOtp()}
              class="text-white bgcolor focus:ring-4 focus:outline-none focus:ring-blue-200 font-medium rounded-lg text-sm px-5 py-2.5 inline-flex justify-center w-full h-[50px] text-center items-center"
            >
              <span>Resend Code</span>
              {resendLoading && (
                <span className="w-5" style={{ transform: "scale(0.3)" }}>
                  <LoaderStyleOne />
                </span>
              )}
            </button>
          </Fragment>
        )}
      </div>
      {showButton &&
        <div className="text-center mt-2">
          <button
            disabled={loading}
            className="text-sm text-white w-full h-[50px] font-semibold flex justify-center bg-qblue items-center"
            onClick={() => handleVerify()}
          >
            <span>Verify</span>
            {loading && (
              <span className="w-5 " style={{ transform: "scale(0.3)" }}>
                <LoaderStyleOne />
              </span>
            )}
          </button>
        </div>
      }
    </Dialog>
  );
}

export default VerifyOtp;